// import FullScreenLoader from "components/Dashboard/FullScreenLoader"
import React, { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { getRefferedMemoLoans } from "services/LoanService";
import FilterComp from "../FilterComp";
import { getAppColumns } from "./appColumns";
import { observer } from "mobx-react-lite";
import { Table } from "antd";
import { usePaginate } from "hooks/usePagination";
import SuperUserService from "components/superuser/SuperUserService";

function FilterHeader({ globalFilter, setGlobalFilter }) {
  return (
    <div className="flex items-center justify-between gap-8 my-2">
      <div className="flex-1">
        <FilterComp filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
    </div>
  );
}

const MemoLoanComp = ({ admin_role }) => {
  const { setPage, page, limit, setLimit } = usePaginate();
  const [searchQuery, updateSearchQuery] = useState("");
  const { data: refferedLoansResponse, isLoading } = useQuery(
    ["approved-loans", { page, limit, searchQuery }],
    () => getRefferedMemoLoans({ page, limit, search: searchQuery }),
  );

  const setSearchQuery = (queryString) => {
    updateSearchQuery(queryString);
    setPage(1);
    setLimit(10);
  };

  const [esLoans, setEsLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const getLoans = async () => {
      const [data] = await SuperUserService.getLoans();
      setLoading(false);
      if (data) {
        setEsLoans(data?.data);
      }
    };
    getLoans();
  }, []);

  const filterData = (arrData) => {
    return arrData;
  };

  const columns = useMemo(() => {
    return getAppColumns(admin_role);
  }, [admin_role]);

  const data = useMemo(() => {
    const referredLoans = refferedLoansResponse?.data?.loans;
    if (!referredLoans) return [];
    return referredLoans;
  }, [refferedLoansResponse]);

  const pagination = useMemo(() => {
    return {
      nextPageUrl: null,
      offset: 0,
      limit: 10,
      total: refferedLoansResponse?.data?.total ?? 10,
      page: 1,
      prevPage: null,
      prevPageUrl: null,
      nextPage: null,
      totalPages: 1,
      ...refferedLoansResponse?.data?.pagination,
    };
  }, [refferedLoansResponse]);

  const getLoanStats = () => {
    const allLoans = data.map((loan) => loan.amount);

    const esLoansData = esLoans
      .filter((loan) => loan.status !== "disbursed")
      .map((loan) => loan.amount);
    const esLoanAmount = esLoansData.reduce((acc, amount) => acc + amount, 0);

    const totalAmount =
      allLoans.length > 0
        ? allLoans.reduce((a, b) => a + b, 0) + esLoanAmount
        : 0;

    return {
      total: allLoans.length,
      totalAmount,
    };
  };

  return (
    <>
      <div>
        <FilterHeader
          globalFilter={searchQuery}
          setGlobalFilter={setSearchQuery}
        />
        <div className="">
          <Table
            loading={isLoading || loading}
            columns={columns}
            pagination={{
              total: pagination.total,
              current: pagination.page,
              onShowSizeChange: (_, size) => {
                setLimit(size);
              },
              onChange: (pageNumber) => {
                setPage(pageNumber);
              },
              pageSize: limit,
              nextIcon: () => {
                const next = () =>
                  pagination.nextPage
                    ? setPage(pagination.nextPage)
                    : undefined;
                return (
                  <button onClick={next}>
                    {" "}
                    <i className="bi bi-chevron-right"></i>
                  </button>
                );
              },
              prevIcon: () => {
                const prev = () =>
                  pagination.prevPage
                    ? setPage(pagination.prevPage)
                    : undefined;

                return (
                  <button onClick={prev}>
                    {" "}
                    <i className="bi bi-chevron-left"></i>
                  </button>
                );
              },
            }}
            dataSource={filterData(data)}
            scroll={{ x: "max-content" }}
            footer={() => {
              const { total } = getLoanStats();
              return (
                <div className="flex items-center  justify-between">
                  {/* <p><span className="font-medium">Total Loan Amount</span> : ₦{totalAmount.toLocaleString()}</p> */}
                  <p>
                    <span className="font-medium">Total Loan</span> :{total}
                  </p>
                </div>
              );
            }}
          />
        </div>
      </div>
    </>
  );
};

export default observer(MemoLoanComp);
